import en from './locale/en.json';
import zh_CN from './locale/zh_CN.json';

export default {
  en,
  zh_CN,
};
